import React, { useContext } from 'react';
import { Route, ScrollToTop, Switch } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';

import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';
import './styles/global-styles.scss';
import './styles/cpr.scss';

export const App = () => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel } = useContext(ExperienceContext);
  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route exact path={routes.home.path}>
          <routes.home.component />
        </Route>
        <Route exact path={routes.contentPage.path}>
          <routes.contentPage.component />
        </Route>
        <Route path="/error">
          <Error />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </>
  );
};

App.propTypes = {};

App.defaultProps = {};
